import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

export const PARTY_ROLE_TYPES_IDS = {
  OWNER: 13,
  INTERNAL_BDM_RELATIONSHIP_TYPE: 4,
  SALES_PERSON_SALES_SUPPORT: 22,
  INTERNAL_BDM: 136,
  INTERNAL_LCA_SALES_SUPPORT: 134,
  INTERNAL_FIRSTMAC_SALES_SUPPORT: 135,
};

@Injectable()
export class ClientService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('ClientService');
  }

  public retrieveParentsWithRelationshipTypeId(childId, relationshipTypeId): Observable<any> {
    return this.http
      .get<any[]>(`${environment.api.client}/party-role/${childId}/parents/${relationshipTypeId}`, httpOptions);
  }

  public retrieveChildrensWithRelationshipTypeId(parentId, relationshipTypeId): Observable<any> {
    return this.http
      .get<any[]>(`${environment.api.client}/party-role/${parentId}/children/${relationshipTypeId}`, httpOptions);
  }

  public retrievePartyRoles(partyId) {
    return this.http
      .get<any[]>(`${environment.api.client}/party/${partyId}/party-roles`, httpOptions);
  }

  public getAddress(addressId) {
    return this.http.get(`${environment.api.client}/address/${addressId}`, httpOptions);
  }

  public sendEmail(data) {
    return this.http
    .post<any[]>(`${environment.api.client}/comm/email`, data, httpOptions);
  }

  public retrievePartyRole(partyRoleId) {
    return this.http
      .get<any[]>(`${environment.api.client}/party/party-role/${partyRoleId}`, httpOptions);
  }

  public retrieveParty(partyId) {
    return this.http
      .get<any[]>(`${environment.api.client}/party/${partyId}`, httpOptions);
  }

  public async retrievePartyInfoFromPartyRole(partyRoleId) {
    const partyRoleResult = await this.retrievePartyRole(partyRoleId).toPromise();
    const partyRole: any = partyRoleResult;

    const partyResult = await this.retrieveParty(partyRole.partyID).toPromise();
    const party = partyResult;

    return {
      partyRole,
      party,
    };
  }

  public retrieveLogins(partyId) {
    return this.http
      .get<any[]>(`${environment.api.client}/party/${partyId}/logins`, httpOptions);
  }

  getPartyEmailAddresses(id: number): Promise<any> {
    return this.http.get(`${environment.api.client}/party/${id}/emails`, httpOptions).toPromise();
  }

  getPartyPhoneList(id: number): Promise<any> {
    return this.http.get(`${environment.api.client}/party/${id}/phones`, httpOptions).toPromise();
  }

  public retrieveBrokers(partyRoleId) {
    return this.http
      .get<any[]>(`${environment.api.client}/party-role/${partyRoleId}/brokers`, httpOptions);
  }

  // we need to fix this
  public listPartyRoleBySuiteType(prs, prt, name) {
    return this.http
      .get<any[]>(`${environment.api.client}/party/search?pt&prt=${prt}&prc&prg=&prs=${prs}&name=${name}&g=false&oid=&mineOnly=false&p=&ps=100`, httpOptions);
  }

  public getBrokerAdditional(prid: number) {
    return this.http.get(`${environment.api.client}/party-role/${prid}/brokers`, httpOptions)
      .pipe(
        catchError(this.handleError('getBrokerAdditional', []))
      );
  }
}
